<template>
  <div class="section section--nonmember">
    <div class="columns">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">
        <h1 class="subtitle">パスワード再設定</h1>
        <p class="block">
          ログインパスワードの再設定を行います。<br />以下の項目を入力し、「確認メールを送る」ボタンを押してください。
        </p>
        <input
          class="input"
          type="email"
          v-model="email"
          name="forgotPassword_email"
          placeholder="メールアドレス"
        />
        <div class="button__wrap">
          <b-button
            class="button__grad"
            @click="passwordReset"
            :loading="sending"
          >
            確認メールを送る
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '@/plugins/firebase';

export default {
  name: 'ForgotPassword',
  data: function () {
    return {
      email: '',
      sending: false
    };
  },
  methods: {
    async passwordReset() {
      this.sending = true;
      auth.languageCode = 'ja';
      try {
        await auth.sendPasswordResetEmail(this.email);
        this.sending = false;
        this.$router.push('/signin');
      } catch (err) {
        this.sending = false;
        let message =
          'ログインできなくなっています。しばらく経ってからまたお試しください。';

        switch (err.code) {
          case 'auth/invalid-email':
            message = 'メールのフォーマットが間違っています。';
            break;
          case 'auth/user-not-found':
            message = 'ユーザーが存在していなません。';
            break;
        }

        this.$buefy.toast.open({
          duration: 3500,
          message: message,
          type: 'is-danger'
        });
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/forgot-password.scss';
</style>
